import _assign from 'lodash/assign';

import {
  ApiResponse,
  convertSortToString,
  PhotoId,
  PhotoPatch,
  PhotoPost,
  Property,
  PropertyFilters,
  PropertyId,
  PropertyPatchRequest,
  PropertyPostRequest,
  PropertySlug,
  PropertyTourRequest,
} from '@arrived/models';

import { api } from './api';
import { buildMultipartFormData, getQueryStringFromFilters, unwrapApiResponse } from './utils';

export const getProperties = async (filters?: PropertyFilters) => {
  const parsedFilters = _assign({}, filters, { sort: filters?.sort?.map(convertSortToString) });

  const response = await api.get<ApiResponse<Property[]>>('/properties', { params: parsedFilters });

  return unwrapApiResponse(response.data);
};

export const getProperty = async (propertyId: PropertyId) => {
  const response = await api.get<ApiResponse<Property>>(`/properties/${propertyId}`);

  return unwrapApiResponse(response.data);
};

export const postNewProperty = async (request: PropertyPostRequest) => {
  const response = await api.post<ApiResponse<Property>>('/properties', request);

  return unwrapApiResponse(response.data);
};

export const postCloneProperty = async (propertyId: PropertyId) => {
  const response = await api.post<ApiResponse<Property>>(`properties/${propertyId}/clone`);

  return unwrapApiResponse(response.data);
};

export const patchProperty = async (request: PropertyPatchRequest) => {
  const response = await api.patch<ApiResponse<Property>>(`/properties/${request.id}`, request);

  return unwrapApiResponse(response.data);
};

export const deleteProperty = async (propertyId: PropertyId) => {
  const response = await api.delete<ApiResponse<Property>>(`/properties/${propertyId}`);

  return unwrapApiResponse(response.data);
};

export const getListedProperties = async (filters?: PropertyFilters) => {
  const parsedFilters = _assign({}, filters, { sort: filters?.sort?.map(convertSortToString) });

  const response = await api.get<ApiResponse<Property[]>>('/properties/listed', { params: parsedFilters });

  return unwrapApiResponse(response.data);
};

export const getListedProperty = async (slug: PropertySlug) => {
  const response = await api.get<ApiResponse<Property>>(`/properties/listed/${slug}`);

  return unwrapApiResponse(response.data);
};

export const postRequestPropertyTour = async (request: PropertyTourRequest) => {
  const response = await api.post<ApiResponse<PropertyTourRequest>>(`/properties/${request.propertyId}/tours`, request);

  return unwrapApiResponse(response.data);
};

// TODO: buildMultipartFormData hasn't been tested
export const postPropertyPhoto = async (propertyId: PropertyId, request: PhotoPost, position?: number) => {
  const queryParameters = position ? getQueryStringFromFilters({ position }) : '';
  const { body, headers } = buildMultipartFormData(request);
  const response = await api.post<ApiResponse<Property>>(`/properties/${propertyId}/photos${queryParameters}`, body, {
    headers,
  });

  return unwrapApiResponse(response.data);
};

export const patchPropertyPhoto = async (propertyId: PropertyId, photoId: PhotoId, request: PhotoPatch) => {
  const response = await api.patch<ApiResponse<Property>>(`/properties/${propertyId}/photos/${photoId}`, request);

  return unwrapApiResponse(response.data);
};

export const deletePropertyPhoto = async (propertyId: PropertyId, photoId: PhotoId) => {
  const response = await api.delete<ApiResponse<Property>>(`/properties/${propertyId}/photos/${photoId}`);

  return unwrapApiResponse(response.data);
};
